const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLookupBatch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#E2F5F6",
    style: {
      fill: "#E2F5F6",
      fill: "color(display-p3 0.8871 0.9592 0.9663)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0602 10.653C19.4935 10.0264 18.5469 9.71302 17.1735 9.71302H17.0135V9.68635C17.0135 8.56635 17.0135 7.17969 14.5069 7.17969H13.4935C10.9869 7.17969 10.9869 8.57302 10.9869 9.68635V9.71969H10.8269C9.44685 9.71969 8.50685 10.033 7.94019 10.6597C7.28019 11.393 7.30019 12.3797 7.36685 13.053L7.37352 13.0997L7.41764 13.563C7.43191 13.7127 7.51266 13.8482 7.63881 13.9302C7.79917 14.0344 8.02039 14.1754 8.16019 14.253C8.25352 14.313 8.35352 14.3664 8.45352 14.4197C9.59352 15.0464 10.8469 15.4664 12.1202 15.673C12.1802 16.2997 12.4535 17.033 13.9135 17.033C15.3735 17.033 15.6602 16.3064 15.7069 15.6597C17.0669 15.4397 18.3802 14.9664 19.5669 14.273C19.6069 14.253 19.6335 14.233 19.6669 14.213C19.9106 14.0752 20.1628 13.908 20.3966 13.7414C20.5101 13.6605 20.5823 13.5343 20.5977 13.3958L20.6002 13.373L20.6335 13.0597C20.6402 13.0197 20.6402 12.9864 20.6469 12.9397C20.7002 12.2664 20.6869 11.3464 20.0602 10.653ZM14.7269 15.2197C14.7269 15.9264 14.7269 16.033 13.9069 16.033C13.0869 16.033 13.0869 15.9064 13.0869 15.2264V14.3864H14.7269V15.2197ZM11.9402 9.71302V9.68635C11.9402 8.55302 11.9402 8.13302 13.4935 8.13302H14.5069C16.0602 8.13302 16.0602 8.55969 16.0602 9.68635V9.71969H11.9402V9.71302Z",
    fill: "#4A878D",
    style: {
      fill: "#4A878D",
      fill: "color(display-p3 0.2902 0.5307 0.5542)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6456 15.2827C20.0003 15.1168 20.4077 15.3977 20.3723 15.7877L20.1601 18.1258C20.0201 19.4592 19.4734 20.8192 16.5401 20.8192H11.4601C8.52672 20.8192 7.98006 19.4592 7.84006 18.1325L7.63935 15.9247C7.6043 15.5392 8.00224 15.2587 8.35586 15.416C9.11559 15.754 10.2561 16.237 11.0298 16.4531C11.1933 16.4988 11.3259 16.6173 11.404 16.7681C11.8248 17.5809 12.6865 18.0125 13.9134 18.0125C15.1282 18.0125 16 17.5642 16.4226 16.7483C16.5008 16.5974 16.6338 16.4789 16.7975 16.4328C17.6223 16.2004 18.8451 15.6572 19.6456 15.2827Z",
    fill: "#4A878D",
    style: {
      fill: "#4A878D",
      fill: "color(display-p3 0.2902 0.5307 0.5542)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookupBatch);
export default __webpack_public_path__ + "static/media/lookup-batch.053b412d0b4707265eec6f27c2bd47b1.svg";
export { ForwardRef as ReactComponent };